import { ArrowRight, BookOpen, Clock3, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { gameGuides } from "../gameGuides";

export function TutorialsPage() {
  return (
    <section className="page-shell guide-library">
      <div className="page-intro">
        <span className="eyebrow">HOW TO PLAY</span>
        <h1>Learn a game in a minute.</h1>
        <p>
          Clear rules, quick steps, and a few useful tips for every game you can play on Topzle.
        </p>
      </div>
      <div className="guide-grid">
        {gameGuides.map((guide) => (
          <article className={`guide-card guide-${guide.color}`} key={guide.id}>
            <div className="guide-card-art" aria-hidden="true">
              <span>{guide.symbol}</span>
            </div>
            <div className="guide-card-copy">
              <span className="eyebrow">{guide.tagline}</span>
              <h2>{guide.name}</h2>
              <p>{guide.summary}</p>
              <div className="guide-facts">
                <span>
                  <Users /> {guide.players}
                </span>
                <span>
                  <Clock3 /> {guide.time}
                </span>
              </div>
              <Link className="text-link" to={`/how-to-play/${guide.id}`}>
                <BookOpen /> Read the guide <ArrowRight />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
